// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgfa[data-v-d3d15ca4]{display:flex;justify-content:center;align-items:center;flex-direction:column;background-color:#fff;padding:1.01333rem 0;width:100%}.imgfa .imgdefault[data-v-d3d15ca4]{height:2.13333rem;width:2.13333rem;margin-bottom:.74667rem}.imgfa .text[data-v-d3d15ca4]{color:#2b3447;font-size:.42667rem}.imgfa .refreshbtn[data-v-d3d15ca4]{margin-top:.42667rem;font-size:.37333rem;color:#818999}", ""]);
// Exports
module.exports = exports;
